<div class="card" *ngIf="equipment">
  <div class="card-header">
    <div class="card-header-title my-2">
      <lib-terminal-header
        [equipment]="equipment"
        [link]="'/farming/' + equipment.serialNumber + '/datalogger'"
        [showStatusIcon]="true"
        [connected]="Number(equipment.connected)"
      ></lib-terminal-header>
    </div>
  </div>
  <div class="row mx-md-1" *ngIf="module !== undefined">
    <app-datalogger-dashboard-terminals-general
      [terminal_vid]="equipment.serialNumber.toString()"
      [elementsDisposition]="2"
      [module]="module"
    ></app-datalogger-dashboard-terminals-general>
  </div>
</div>

<div class="card" *ngIf="!equipment && terminal">
  <div class="card-header">
    <div class="card-header-title my-2">
      <lib-terminal-header
        [equipment]="terminal"
        [link]="'/farming/' + terminal.vid + '/datalogger'"
        [showStatusIcon]="true"
        [connected]="terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED ? 2 : 0"
      ></lib-terminal-header>
    </div>
  </div>
  <div class="row my-4 mx-2" *ngIf="terminal.enabled !== TERMINAL_ENABLED_TEMPORARY_DISABLED">
    <i>{{ 'no_results' | translation }}</i>
  </div>
  <div class="row mx-2" *ngIf="terminal.enabled === TERMINAL_ENABLED_TEMPORARY_DISABLED">
    <app-terminal-placeholder-data
      [terminalType]="'datalogger'"
      [size]="'small'">
    </app-terminal-placeholder-data>
  </div>
</div>
